"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _oAuth = _interopRequireDefault(require("../../../services/o-auth"));
var _index = require("../index.types");
const useOAuthInterceptor = function () {
  const service = (0, _oAuth.default)();
  return async function (config) {
    try {
      var _config$OAuth, _config$OAuth2;
      if (!(0, _index.isEOSRequestConfig)(config)) return config;
      if ((_config$OAuth = config.OAuth) !== null && _config$OAuth !== void 0 && _config$OAuth.enabled && (_config$OAuth2 = config.OAuth) !== null && _config$OAuth2 !== void 0 && _config$OAuth2.resource) {
        config.headers.Authorization = await service.findOAuthToken(config.OAuth.resource);
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  };
};
var _default = exports.default = useOAuthInterceptor;